import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import keyBy from 'lodash/keyBy';

import mapDispatch from '~/misc/mapDispatch';

import css from './index.css';

class Input extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const props = this.props;
    const mods = props.mods || [];
    const index = keyBy(mods);
    const cn = cs(
      css.label,
      {
        [css.half]: index.half,
        [css.strench]: index.strench,
        [css.floatLef]: index.floatLef,
        [css.floatRigt]: index.floatRigt,
        [css.clearFix]: index.clearFix,
      }
    );
    const inputcn = cs(
      css.input,
      {
        [css.grey]: props.readonly,
      }
    );
    return (
      <div>
        <label htmlFor={props.label} className={cn}>
          {props.title && (<div className={css.title}>{props.title}
            {props.titleInfo && (<span className={css.titleInfo}>{props.titleInfo}</span>)}
          </div>)}
          <div className={css.wrap}>
            {props.type === 'password'
              ? <input
                type={props.type}
                className={inputcn}
                autoComplete='off'
                readOnly={props.readonly || ''}
                name={props.label}
                placeholder={props.placeholder || ''}
                data-inputType={props.type ? props.type : 'text'}
                value={props.defaultValue}
                onChange={props.fnChange}
                onBlur={props.fnBlur}
                onFocus={props.fnFoucs}
              />
              : <textarea
                className={inputcn}
                autoComplete='off'
                readOnly={props.readonly || ''}
                name={props.label}
                placeholder={props.placeholder || ''}
                data-inputType={props.type ? props.type : 'text'}
                value={props.defaultValue}
                onChange={props.fnChange}
                onBlur={props.fnBlur}
                onFocus={props.fnFoucs}
              />
            }
            
            {
              props.error && <span className={cs(css.errorTips, css.errorBottom)}>{props.error}</span>
            }
            {
              props.suffix && <div className={cs(css.suffix)}>{props.suffix()}</div>
            }
          </div>
        </label>
      </div>
    );
  }
}

export default connect(null, mapDispatch({}))(Input);



// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/share/Input/index.js